module.exports = __webpack_public_path__ + "img/ico-close-white.f796df2c.svg";